import React, { useState } from "react"
import { TextField, Select, MenuItem, FormControl, Box, Typography, IconButton, Chip, Divider } from "@mui/material"
import Flag from "react-world-flags"
import { 
	AudienceOuter, 
	AudienceTitle, 
	AudienceBox, 
	AudienceLabel,
	 DemsWrapper, 
	EditDemButton,
	 CountryFlag, 
	CountryRegion,
	 CountryLanguage, 
	ChipLabel,
	ChipLabelDems
 } from "./styles"

import DemPicker from "./demPicker"

function AudienceSelection({
	regions,
	region,
	setRegion,
	demographicsHome,
	setDemographicsHome,
	responses,
	setResponses,
	isDemLangLocal,
	setIsDemLangLocal,
	error,
	estimateAudienceCost
}) {
	const [demPickerOpen, setDemPickerOpen] = useState(false)

	const [selectedCategory, setSelectedCategory] = useState(null)
	const [selectedDemographic, setSelectedDemographic] = useState(null)


	const toggleDrawerFromChip = (newOpen, categoryId, demographicId) => () => {
		setDemPickerOpen(newOpen)
		setSelectedCategory(categoryId)
		setSelectedDemographic(demographicId)
	}

	const handleChipDelete = (categoryId, demographicId) => {
		const updatedDemographics = demographicsHome.map((category) => {
			if (category.id === categoryId) {
				const updatedDemographics = category.demographics.map((demographic) => {
					if (demographic.id === demographicId) {
						const updatedValues = demographic.demographic_values.map((value) => {
							return {
								...value,
								selected: false
							}
						})
						return {
							...demographic,
							demographic_values: updatedValues
						}
					}
					return demographic
				})
				return {
					...category,
					demographics: updatedDemographics
				}
			}
			return category
		})

		setDemographicsHome(updatedDemographics)
	}

	return (
		<AudienceOuter>
			
		<AudienceBox>
				<AudienceTitle>Number of responses</AudienceTitle>
					<TextField
						size='medium'
						type='number'
						classes={{ root: 'MediumSize' }}
						fullWidth
						InputProps={{ inputProps: { min: 1, max: 10000 } }}
						value={responses}
						onChange={(e) => setResponses(e.target.value)}
						error={error && Object.keys(error).length !== 0 && error.type === "warning"}
					/>
			</AudienceBox>
			<AudienceBox>
				<AudienceTitle>Audience selection</AudienceTitle>

					<AudienceLabel>Region</AudienceLabel>
					<FormControl fullWidth>
						<Select
							size='medium'
							sx={{ backgroundColor: "white" }}
							labelId='region-label'
							value={region}
							onChange={(e) => setRegion(e.target.value)}
						>
							{regions.map((region) => (
								<MenuItem key={region.id} value={region.id}>
									<CountryFlag>
										<Flag code={region.code === "UK" ? "GB" : region.code} height='16' />
									</CountryFlag>
									<CountryRegion>{region.text}</CountryRegion>
									<CountryLanguage>{region.language_text}</CountryLanguage>
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</AudienceBox>
				
				<AudienceBox>
					<AudienceLabel> Demographics
					<EditDemButton>
						<IconButton size='small' variant='contained' onClick={() => { document.body.style.overflow = "hidden"; setDemPickerOpen(true)}}>
							<svg width={16} height={18} fill="none">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M9.75.992a3.247 3.247 0 114.59 4.592l-6.328 6.328c-.356.357-.574.575-.817.764a4.996 4.996 0 01-.923.57c-.278.133-.57.23-1.048.39l-2.228.742-.534.178a1.332 1.332 0 01-1.685-1.684l.92-2.762c.16-.479.257-.771.39-1.049.156-.327.347-.637.57-.923.19-.243.407-.46.764-.817L9.75.992zM2.966 13.07l-.704-.704.607-1.821c.177-.53.25-.746.345-.946.117-.246.26-.478.428-.692.136-.175.296-.337.692-.732l4.909-4.91a5.042 5.042 0 001.123 1.7 5.043 5.043 0 001.7 1.125l-4.909 4.909c-.395.395-.557.555-.732.691-.214.168-.446.311-.692.428-.2.095-.415.168-.945.345l-1.822.607zm10.096-7.976a3.358 3.358 0 01-.379-.108 3.78 3.78 0 01-1.433-.904c-.5-.5-.764-1.03-.904-1.433a3.368 3.368 0 01-.107-.38l.393-.393A1.997 1.997 0 1113.457 4.7l-.394.394zM.708 17.334c0-.346.28-.626.625-.626h13.334v1.25H1.333a.625.625 0 01-.625-.625z"
									fill="#515860"
								/>
							</svg>
						</IconButton>
					</EditDemButton>
					</AudienceLabel>
	
			
				<DemsWrapper>
						{demographicsHome.map((category) =>
							category.demographics.map((demographic, index) => {
								const selectedValues = demographic.demographic_values.filter((value) => value.selected)
								let displayText = ""

								if (selectedValues.length > 0) {
									if (demographic.format_id === 8) {
										const min = Math.min(...selectedValues.map((value) => +value.text))
										const max = Math.max(...selectedValues.map((value) => +value.text))
										displayText = `${min}-${max}`
									} else {
										displayText = selectedValues
											.map((value) => (!isDemLangLocal && value.override_en ? value.override_en : value.text))
											.join(", ")
									}

									return (
										<Chip
											key={demographic.id}
											label={[
												<ChipLabel>
													{`${
														!isDemLangLocal && demographic.override_en ? demographic.override_en : demographic.text
													}: `}
											
													<ChipLabelDems>{displayText.length > 75 ? `${displayText.substring(0, 75)}...` : displayText}</ChipLabelDems>
													
												</ChipLabel>
											]}
											onClick={toggleDrawerFromChip(true, category.id, demographic.id)}
											onDelete={() => handleChipDelete(category.id, demographic.id)}
											// sx={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
										/>
									)
								}

								return null
							})
						)}
				</DemsWrapper>
			</AudienceBox>
		

			<div>
			{demPickerOpen && demographicsHome.length > 0 ? 
					<DemPicker
					demPickerOpen={demPickerOpen}
					demographicsHome={demographicsHome}
					setDemographicsHome={setDemographicsHome}
					regions={regions}
					estimateAudienceCost={estimateAudienceCost}
					selectedCategory={selectedCategory}
					selectedDemographic={selectedDemographic}
					isDemLangLocal={isDemLangLocal}
					setIsDemLangLocal={setIsDemLangLocal}
					onClose={() => {document.body.style.overflow = "visible"; setDemPickerOpen(false)}}
					/>
			: null
			}
					
				
			</div>
		</AudienceOuter>
	)
}

export default AudienceSelection
